import type { Text } from '../types/form'

type InputKind = 'radioGroup' | 'checkboxGroup' | 'plainText' | 'attachment' | 'multiAttachment'
type InputRenderHint = 'radio' | 'dropdown' | 'yesNo' | 'confirmation' | 'checkbox'
type InputItemOption = {
    id: string
    text: Text
    scoreIfSelected: Maybe<number>
    scoreIfNotSelected: Maybe<number>
}

export class Input {
    constructor(language: string, inputData?: Partial<Input>) {
        this.language = language
        if (inputData) {
            Object.assign(this, inputData)
            this.items?.forEach((item) => {
                if (!item.scoreIfSelected) item.scoreIfSelected = null
                if (!item.scoreIfNotSelected) item.scoreIfNotSelected = null
            })
        } else {
            this.text = this.textObject()
        }
    }

    private language: string
    // @ts-ignore
    id = crypto['randomUUID']()
    isRequired = false
    kind = 'radioGroup' as InputKind
    renderHint = null as Maybe<InputRenderHint>
    text = null as Maybe<Text>
    helpText = null as Maybe<Record<string, string>>
    weight = null as Maybe<number>
    items = null as Maybe<InputItemOption[]>
    dependsOn = null as Maybe<string>
    scoreLimitMedium = null as Maybe<number>
    scoreLimitHigh = null as Maybe<number>

    supportScoring = false
    name = `form_fe['revision.heading_inputItem']`
    icon = 'fa fa-edit'

    get isFileInput() {
        return this.kind === 'attachment' || this.kind === 'multiAttachment'
    }

    get isSelectionInput() {
        return this.kind === 'radioGroup' || this.kind === 'checkboxGroup'
    }

    addItem({ text }: { text: Maybe<string> } = { text: null }) {
        if (!this.items) this.items = []

        this.items.push({
            // @ts-ignore
            id: crypto['randomUUID'](),
            scoreIfNotSelected: null,
            scoreIfSelected: null,
            text: { [this.language]: text },
        })
    }

    removeItem(id: string) {
        if (!this.items) return

        this.items = this.items.filter((item) => item.id !== id)
    }

    private textObject(value: Maybe<string> = null) {
        return { [this.language]: value }
    }
}
